"use client";

import { usePerpTradeType } from "#/store/perps/tradePanel/perpTradeType";

import { PerpLimitOrder } from "./components/PerpLimitOrder/PerpLimitOrder";
import { PerpMarketOrder } from "./components/PerpMarketOrder/PerpMarketOrder";
import { PerpRFQ } from "./components/PerpRFQ/PerpRFQ";

export const PerpTradeDetails: React.FC = () => {
  const { isMarket, isLimit, isRFQ } = usePerpTradeType();

  return (
    <>
      {isMarket && <PerpMarketOrder />}
      {isLimit && <PerpLimitOrder />}
      {isRFQ && <PerpRFQ />}
    </>
  );
};
